const allproducts = [
  {
    id: 1,
    title: "الساعه الذكيه watch 8",
    price: 10,
    description: `
    وصل حديثاً
🔥ساعه  Ultra watch 8  الأصلية الجيل الثامن أحدث إصدار 2023🔥 حرق سعر العرض لفتره محدوده 🔥

🔥 مع 2كستك  و لزقة شاشه هدية 🔥

⏰ حرق سعر فقط ب9.99 دينار وال3ساعات ب 28دينار  العرض لفتره محدوده اغتنم العرض ⏰

✅مكفوله و مضمونة لعامين💯✅

🛑الرجاء عدم مقارنة المنتج  بمنتج اخر، فمنتجنا إصدار 2023، و مواصفاته الداخلية و المعالج أسرع بكثير من منافساتها و مكفول لسنتين 🛑

✅ ضد الماء.
✅ يمكن تشغيل جميع التطبيقات من خلالها.
✅ تشغيل الشاشة عند النظر  أو من خلال حركه اليد.
✅ تحتوي على ذاكره داخليه كبيره 64G
✅ يمكن تنزل ارقام الهاتف والصور على الساعه وحفظها.
✅ ترسل ونستقبل مكالمات من خلالها وتفتح اشعارات الفيس والواتس وجميع الاشعارات الأخرى .
✅ عجل و كبسة شغالية.
✅ تعمل على جميع الأجهزة.
✅ شاشه كامله بحجم1.81انش فل تتش بالكامل.
✅ خاصيه انقسام الشاشة إلى قسمين يعني بتقدر تحط قائمه اختصارات على خلفيه الشاشة
✅ قياس درجة حرارة الجسم 🌡
✅ يوجد بها ألعاب 🕹
✅نظام الأوامر الصوتية 🎙
✅ رجاج
✅ منبه عند الجلوس لفترة طويلة
✅ ضد  الماء بمعيار  IP69 الأحدث.
✅ تدعم اللغة العربية بشكل كامل و تدعم كل اللغات.
✅ التحكم بالكاميرا على الهاتف
✅ إمكانية وضع باسورد للساعة 
✅ اظهار رقم و اسم المتصل
✅ إمكانية الرد على المكالمات و التحدث منها مباشرة ( مزودة بميكروفون و سماعة )
✅ قياس دقات القلب و ضغط الدم و الأكسجين و حرارة الجسم
✅ تحتوي على عدة واجهات خلفيات للساعة يمكن للمستخدم الاختيار بينها.
✅ وضع الرياضة : كرة القدم⚽️، كرة الطائرة🏐، التنس🎾، اليوغا 🧘‍♂️، الركض🏃، المشي🚶، التسلق 🧗 الخ..
✅ بطارية بسعة 5500 مللي امبير, تدوم لعشر أيام بشحنه الواحده🔋
✅ شاحن مغناطيسي (مرفق في العلبة).🔌
✅ إمكانية اجراء واستقبال مكالمات مع صوت واضح ومسموع لدى الطرفين ⁦
✅ إمكانية قراءة الرسائل من جميع التطبيقات مثل الواتس و الفيس من الساعة مباشرة
✅ اظهار الاشعارات من كل التطبيقات الساعة مباشرة
✅  ميزة مراقبة النوم اذا كان عميق او خفيف و عدد الاستيقاظ من النوم😴
✅ بتقدر تغير الخلفيات ووضع أي صورة شخصيه خلفيه للساعه
✅ قابلية تغيير الكاستك بسهولة.
✅ الالة الحاسبة.✖️➗➖➕
✅ ساعة الإيقاف.⏱
✅ التقويم.🗓
✅ المنبه.⏰
✅وميزات أخرى عديده وكثيره 

⏰ حرق سعر فقط ب9.99 دينار وال3ساعات ب 28دينار  العرض لفتره محدوده اغتنم العرض⏰

🚘يضاف 2 دينار اجرة توصيل لإي مكان بالممكلة🚘

🎨متوفرة باللون الأسود والأبيض والزهري.

📩 للطلب و الاستفسار الرجاء الارسال لبريد الصفحة او الواتس 📩
0779243364
        `,
    category: "ساعات",
    images: [
      {
        url: "https://i.ibb.co/59jdwgY/Whats-App-Image-2022-12-19-at-12-52-04.jpg",
      },

      { url: "https://m.media-amazon.com/images/I/71v6Aa7Bm4L._AC_SX679_.jpg" },
      {
        url: "https://ae01.alicdn.com/kf/H862121e221f24cccaf0ba66083acde04z/2021-Smart-Watches-IWO-W26-Men-Women-Smartwatch-Bluetooth-Call-ECG-Heart-Rate-Monitor-Sports-Fitness.jpg",
      },
      {
        url: "https://5.imimg.com/data5/SELLER/Default/2021/9/PQ/QD/BT/68248891/w26-smart-watch-with-scroll-working-many-more-exciting-watch-faces-1000x1000.jpg",
      },
      { url: "https://cdn.mos.cms.futurecdn.net/24gnNuzE4ZzsBAtMityAuH.jpg" },

      {
        url: "https://i0.wp.com/mucuruzi.com/wp-content/uploads/2022/03/T500-PLUS-1.png?ssl=1",
      },
      { url: "https://i.ibb.co/t4kMQfL/whitewatch.jpg" },
      { url: "https://i.ibb.co/J2NyS7J/pink-watch.jpg" },
    ],

    image:
      "https://i.ibb.co/59jdwgY/Whats-App-Image-2022-12-19-at-12-52-04.jpg",
    rating: {
      rate: 3.9,
      count: 120,
    },
  },
  {
    id: 2,
    title: "سماعة TWS ",
    price: 8,
    description: `
    🔥 وصل حديثا سماعه TWS, موديل 2023 احدث اصدار و بسعر تحدي !!🔥

⏰ حرق سعر فقط ب 7.99 دينار لفترة محدودة ⏰

✅مكفوله و مضمونة لعام كامل ضد الماء 💯✅

💠#سماعه TWS  أعلى جودة, الاحدث بالسلسة اصدار 2023 سماعة و باوربانك 5500 ملي امبير بنفس الوقت، تخيل السماعة بتعقد معك من 8 إلى 9 ساعات بشحنه الواحدة وغير هيك الباوربانك بشحنها 45 مره, وممكن تشحن التلفون باستخدامه , يعني العلبة وهي مشحونة بتكفيك لأكثر من 350 ساعه !!

#مميزات_المنتج :

💠 تعمل على هواتف الأندرويد و الأيفون ( تعمل على جميع الأجهزة) و الساعات الذكية.
💠الجيل جديد من HIFI Heavy Bass 130AB و الأنقى للموسيقى.
💠تعمل باللمس.
💠أحدث إصدار بلوتوث 5.2( #لا تأخير بصوت_ الألعاب).
💠يمكن الرد على المكالمات و تغير الأغنية و التحكم بالصوت عن طريق لمسها مباشرة.
💠مقاومة للماء و التعرق بشكل كامل و الاتربة IP68.
💠ثبات عالي بالأذن لتناسب الرياضات.
💠مزودة بمانع الضوضاء الخارجية.
💠إمكانية استخدامها لشحن الهاتف كـ POWER BANK ب سعة 5500 مل أمبير !!
💠تقنيه الصوت محيط 9D عالية الجودة #مناسبهجداللألعاب. 
💠تصميم Groove الجميل، و يمكن استخدامه كحاملة للهاتف المحمول.
💠شاشة رقمية ذكية لمعرفه مستوى شحن.
💠تعمل عن بعد 20 متر الى 25 متر عن الهاتف .
💠مصنوعة من مادتي ABS+PVC لتحقيق أعلى متانة و اناقة.

✅ الصورة مطابقة للواقع 100%

🔥 فقط بسعر 7.99دينار لفترة محدودة !! 🔥

🚘يضاف 2 دينار اجرة توصيل لجميع محافظات المملكة 🚘

📩 للطلب والاستفسار الرجاء التواصل معنا عبر رسائل الصفحة او الواتس  📩
0779508092
    `,
    category: "سماعات",
    image:
      "https://i0.wp.com/alyazon.com/wp-content/uploads/2022/04/798563.jpg?fit=1601%2C1601&ssl=1",
    images: [
      {
        url: "https://i0.wp.com/alyazon.com/wp-content/uploads/2022/04/798563.jpg?fit=1601%2C1601&ssl=1",
      },

      { url: "https://i.ibb.co/2h0kGcy/headphone6.jpg" },
      {
        url: "https://www.dhresource.com/0x0/f2/albu/g15/M01/1B/F5/rBVa3WIYmJaAFAb1AAn7lW3tdwE731.jpg",
      },
      {
        url: "https://i0.wp.com/alyazon.com/wp-content/uploads/2022/04/798558.jpg?fit=1601%2C1601&ssl=1",
      },
      {
        url: "https://i0.wp.com/alyazon.com/wp-content/uploads/2022/04/798570.jpg?fit=2160%2C2160&ssl=1",
      },
      {
        url: "https://i0.wp.com/alyazon.com/wp-content/uploads/2022/04/798547-1.jpg?fit=800%2C800&ssl=1",
      },
      {
        url: "https://image.made-in-china.com/2f0j00UbYicqTtVnoa/3500mAh-M10-9d-Tws-5-1-Earphone-Touch-Control-Wireless-Earphones-Stereo-Bass-Headphone-LED-Digital-Display-Earbuds.jpg",
      },
      { url: "https://i.ibb.co/DDtw9cx/powerbank.jpg" },
    ],
    rating: {
      rate: 4.1,
      count: 259,
    },
  },
  {
    id: 3,
    title: "مشط حراري",
    price: 6,
    description: `
 
        مشط حراري لتصفيف شعر الرأس واللحيه بكل سهوله بديل _السشوار والستريت (للشباب والفتيات).
      
         🚘  خدمه التوصيل أينما كنت في الاردن 2 دينار  🚘
        
        ⏰ حرق سعر فقط 6  دينار لفترة محدودة ⏰
        🔥 🔥 🔥    عرض خاص : حبتين  ب 11 دينار فقط  🔥 🔥 🔥 

        مميزاته : ❤
        صناعه كوريه اصلي. 
        كفاله سنه. 
        مناسب للشباب والفتيات لجميع انواع الشعر مهما كان. 
        سهل الإستخدام. 
        تسريحه وأناقه وشعر جذاب  بأقل من دقيقتين. 
        يساعد في فرد  و ترطيب الشعر وتنعيمه،وحمايته  من التلف والتساقط.
        تصميم رائع وأنيق مناسب لحجم اليد. 
        مدة الوصول للحرارة المثالية هي عده ثواني فقط. 
        آمن وفعال توجد طبقة حماية ، لحماية الشعر والجلد من الإحتراق. 
        درجه حراره متعدده، خفيفه  وسط وعاليه تصل إلى 950F بثواني/60Hz200V
        
        ⏰ حرق سعر فقط 6  دينار لفترة محدودة ⏰
        🔥 🔥 🔥    عرض خاص : حبتين  ب 11 دينار فقط  🔥 🔥 🔥 

        للطلب الرجاء التواصل على الواتس`,
    category: "مشط حراري",
    image:
      "https://eg.xpark.com/media/catalog/product/4/d/4d3ea390-c50f-4725-bad9-087d80fe9b23_1.jpg",
    images: [
      {
        url: "https://eg.xpark.com/media/catalog/product/4/d/4d3ea390-c50f-4725-bad9-087d80fe9b23_1.jpg",
      },
      {
        url: "https://n3.sdlcdn.com/imgs/i/7/t/MAXXMON-Beard-Styler-V2-Multigrooming-SDL910429235-4-14f7d.jpg",
      },

      { url: "https://i.ibb.co/TKxsGpc/makwa1.jpg" },
      { url: "https://i.ibb.co/g6j60xh/71nf-kg0lrl-sl1500-1000x1000.webp" },
      { url: "https://i.ibb.co/616SrJW/416f-N0-Enql-L-SY450.jpg" },
      { url: "https://i.ibb.co/vQ6C4qt/b2f1a9fc080b57649a5eca9e2ef6a48a.jpg" },
      {
        url: "https://i.ibb.co/vBnPCs5/c06bd372-b050-4568-b7e8-3f864e02e7d7.jpg",
      },
      {
        url: "https://i.ibb.co/mbZ3s4m/e68ba803-6e17-40bd-a084-687211fa1896.jpg",
      },
      { url: "https://i.ibb.co/8gm6Pkw/fe304ada59507634bd9209d2d95b7186.jpg" },
      {
        url: "https://i.ibb.co/fv9PZtN/H1ceb1dc9b1f9432ea6002936fba6bccc-U.jpg",
      },
      {
        url: "https://i.ibb.co/3vLPC6s/Hbbe090be1f024bdca0c9cc916c6efe7f-C.jpg",
      },
      { url: "https://i.ibb.co/N2kj8jQ/s-l1600.jpg" },
      { url: "https://i.ibb.co/9pzFhHR/styler-v2-1000x1000.webp" },
      { url: "https://i.ibb.co/7RrsqqV/First-Frame.png" },
    ],
    rating: {
      rate: 4.7,
      count: 500,
    },
  },
  {
    id: 4,
    title: "فوم تنظيف",
    price: 10,
    description: `
  🔥بخاخ الفوم الألماني🔥

  🎁هدية مع كل طلب ليفة تنظيق سحرية مخصصة  🎁
  
   المنظف الأقوى يعيد لون الأسطح الجلد و البلاستيك متل ما كانت.✅
   تقنية  الفوم مطور يعمل علي ازاله طبقه الاوساخ المتراكمة علي التابلو او العجل. ✅
    فوم منظف ومزيل لجميع البقع والاوساخ يعيد للسيارة بريقها ولمعتها .✅
    مناسب للاستخدام على الكراسي والسقف والتابلو والموتور والجسم الخارجي السيارة.✅
    يستطيع إزالة أقوى الدهون والبقع العنيدة.✅
    يزيل الاوساخ والأتربة بكل سهوله✅
    يلمع السيارات بشكل فعال جداً ومن أول استخدام.✅
    حجم العبوة كبيره جدا ومناسب للاستخدام أكتر من مرة.✅
  
  🎁هدية مع كل طلب ليفة تنظيق سحرية مخصصة  🎁
  
  🔥 الاثنين بسعر 7 دينار🔥 توصيل مجاني
  🔥 اربعه بسعر 10 دينار🔥 توصيل مجاني
  🔥 الستة بسعر 14 دينار🔥توصيل مجاني
  
  🚘التوصيل مجاني  لجميع محافظات المملكة 
  `,
    category: "فوم تنظيف",
    image:
      "https://dalilalmarefa.com/wp-content/uploads/2022/01/%D8%B7%D8%B1%D9%8A%D9%82%D8%A9-%D8%AA%D9%86%D8%B8%D9%8A%D9%81-%D8%A7%D9%84%D9%85%D8%B7%D8%A8%D8%AE-%D9%85%D9%86-%D8%A7%D9%84%D8%AF%D9%87%D9%88%D9%86-scaled.jpg",
    images: [
      {
        url: "https://www.click2shop.org/wp-content/uploads/2021/03/a2_20fda01d-6236-4e47-8d2c-52801d19fa8d_large.gif",
      },
      {
        url: "https://cdn.youcan.shop/stores/2c523d73da2562a06d584192bc3e4afc/products/wJRdyBQPA6Ha6sD6fR77sA3eRs6LC9kQpwJ8d3WD.jpeg",
      },
      {
        url: "https://kitchen.sayidaty.net/uploads/small/5e/5eecd9d483ad9f591a20ce10b2bda17f_w750_h750.jpg",
      },
      {
        url: "https://dalilalmarefa.com/wp-content/uploads/2022/01/%D8%B7%D8%B1%D9%8A%D9%82%D8%A9-%D8%AA%D9%86%D8%B8%D9%8A%D9%81-%D8%A7%D9%84%D9%85%D8%B7%D8%A8%D8%AE-%D9%85%D9%86-%D8%A7%D9%84%D8%AF%D9%87%D9%88%D9%86-scaled.jpg",
      },
      { url: "https://ethranet.net/user_images/news/16-02-22-531627866.jpg" },
      { url: "https://i.ytimg.com/vi/us-y2niSGvE/sddefault.jpg" },
    ],
    rating: {
      rate: 4.7,
      count: 500,
    },
  },


  {
    "id": 5,
    "title": " 2023 سماعات سبيكر",
    "price": 10,
    "description": `🔥عرض  بدايه السنه نار  🔥

    #سماعات سبيكر مع مايكروفون فقط ب 9.99دينار.
    #وصل حديثا 
    احدث اصدار موديل SPEAKER/ 2023
    
    اغتنم العرض قبل نفاذ الكمية محدوده
    
     #المميزات:-
    صوت عالي واضح ونقي.🔹
    مكفوله لمده سنه. 🔹
    حجم كبير CM18*40🔹
     تحتوي هلى نظام سستم نار 🔥  صوت صاخب وعالي. 🔹
    ريموت للتحكم عن بعد. 🔹
     يمكن  شبكها مع اي جهاز اخر عن طريق البلوتوث WIRELESSاو السلك. 🔹
     راديو.🔹
    تحتوى على قاعده للهاتف.🔹
     تحتوي على Hi_Fi🔹
    تحتوي على مدخل للفلاشه ومدخل للذاكره USB/SD CARD المومري/مدخل للتلفون.🔹
    
    🔥 حرق سعر نار فقط ب 9.99دينار 🔥 اغتنم العرض قبل نفاذ الكمية محدوده .🔹
    
    ❌ الكمية محدودة, سارع بالحجز❌
    
    🚘يضاف 2 دينار اجرة توصيل لإي مكان بالمملكة🚘
    
    📩 للطلب والاستفسار الرجاء التواصل معنا عبر رسائل  الواتس 0779243364  📩
    `,
    "category": "سماعات",
    "image": "https://i.ibb.co/vBV2R6B/1.jpg",
    "images":[
          { url: "https://i.ibb.co/vBV2R6B/1.jpg" },
          { url: "https://i.ibb.co/QjvnmPT/2.jpg"},
          { url: "https://i.ibb.co/BVW7Q1f/3.jpg"},
          { url: "https://i.ibb.co/r336w1T/4.jpg" },
          { url: "https://i.ibb.co/hVmVVsx/5.jpg" },
      ],
    "rating": {
        "rate": 4.7,
        "count": 500
    }
    }
];

export default allproducts;
